import jQuery from 'jquery';
let $ = jQuery;

// define EVENTs
import "HSNDIR/Flyout.js";

/**
* class HSN.FlyoutManager
*
* Coordinates the state of set of [[HSN.Flyout]] instances to ensure that
* their interactions are synchronized.
**/
HSN.FlyoutManager = function (config) {
    /**
    * new HSN.FlyoutManager(config)
    * - config (Object): A configuration object for the [[HSN.FlyoutManager]]
    *   consisting of the following keys:
    *   - flyouts (Array [[HSN.Flyout]]): The [[HSN.Flyout]] instances the [[HSN.FlyoutManager]] is supposed to coordinate.
    **/
    var __scope = this;

    this.Flyouts = config.flyouts;

    $.each(this.Flyouts, function (i, flyout) {
        __scope.Add(flyout);
    });

    $(window).on('keydown', function (event) {
        var keyCode = event.keyCode || event.which;
        if (keyCode != 27) {
            return;
        }
        $.each(__scope.Flyouts, function (i, flyout) {
            flyout.Close();
        });
    });
};
HSN.FlyoutManager.prototype =
    {
        /**
    * HSN.FlyoutManager#Flyouts -> [HSN.Flyout]
    *
    * [[HSN.FlyoutManage#Flyouts]] provides access to the [[HSN.Flyout]] instances it is coordinating.
    **/
        Flyouts: null,

        /**
    * HSN.FlyoutManager#Add(flyout) -> void
    * - flyout (HSN.Flyout): The [[HSN.Flyout]] to be managed.
    *
    * Adds the given [[HSN.Flyout]] to the collection of [[HSN.Flyout]]s that need to be managed and coordinated.
    **/
        Add: function (flyout) {
            var __scope = this;
            flyout.Events.On(HSN.Flyout.EVENT.BEFORE_OPEN, function (flyout) {
                $.each(__scope.Flyouts, function (j, otherFlyout) {
                    if (otherFlyout != flyout) {
                        otherFlyout.Close();
                    }
                });
            }, this);
            this.Flyouts.push(flyout);
        },

        Remove: function (flyout) {
            var __scope = this;
            __scope.Flyouts = $.grep(__scope.Flyouts, function (element, index) {
                if (element == flyout) {
                    element.Close();
                    element.RemoveHandlers();
                    return false;
                }
                else {
                    return true;
                }
            });
        }
    };



// WEBPACK FOOTER //
// ./assets/js/HSN/FlyoutManager.js